"use client";
import type { CmsSidebarFragment } from "@workspace/casino_core/queries/CmsSidebarQuery";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@workspace/frontend-ui";
import LinkComponent from "@workspace/nextjs_utils/src/components/LinkComponent";
import type { FC } from "react";

type Props = {
  brand: CmsSidebarFragment["brand"];
};

const Logo: FC<Props> = ({ brand }) => {
  const { state } = useSidebar();

  if (state === "collapsed") {
    return (
      <div className="flex flex-col justify-center gap-3">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              size="lg"
              className="flex items-center justify-center"
            >
              <LinkComponent href="/">
                <img
                  src={brand?.logoIcon?.url}
                  alt={brand?.name}
                  className="h-6"
                />
              </LinkComponent>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
        <SidebarTrigger className="border-0" />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between">
      <SidebarMenu>
        <SidebarMenuItem>
          <LinkComponent href="/">
            <img
              src={brand?.logoFull?.url}
              alt={brand?.name}
              className="h-[32px]"
            />
          </LinkComponent>
        </SidebarMenuItem>
      </SidebarMenu>
      <SidebarTrigger className="border-0" />
    </div>
  );
};

export default Logo;
